import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
  Spinner,
  cn,
} from '@design-system';

import { Check } from 'lucide-react';

import { useSelector } from 'react-redux';

import { FREEMIUM_BGA_SPONSORED_CTA } from '@shared';

import { selectClient } from '@/model';
import { useBgaInquiry } from '../hooks/use-bga-inquiry';
import { AlertDescription } from '@client/components/ui/alert';

interface BgaEligibilityDialogProps {
  triggerClassName?: string;
}

export function BgaEligibilityDialog({ triggerClassName }: BgaEligibilityDialogProps) {
  const advisorId = useSelector(selectClient)?.advisorId;
  const { open, setOpen, bgaName, setBgaName, submit, isPending, isSuccess, canSubmit } =
    useBgaInquiry(advisorId);

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogTrigger asChild>
        <span
          role="button"
          className={cn('underline! inline! text-start font-semibold', triggerClassName)}
        >
          {FREEMIUM_BGA_SPONSORED_CTA}
        </span>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Check your BGA eligibility</DialogTitle>
          <DialogDescription>
            Tell us which BGA you work with and our team will follow up about eligibility or getting
            contracted.
          </DialogDescription>
        </DialogHeader>

        {isSuccess ? (
          <Alert variant="success">
            <Check />
            <AlertDescription>Thanks, we&apos;ll be in touch about {bgaName}.</AlertDescription>
          </Alert>
        ) : (
          <>
            <div className="grid gap-2">
              <Label htmlFor="bga-name">Your BGA</Label>
              <Input
                id="bga-name"
                value={bgaName}
                placeholder="e.g. Acme Brokerage"
                disabled={isPending}
                onChange={event => setBgaName(event.target.value)}
              />
            </div>
            <DialogFooter>
              <Button
                onClick={submit}
                disabled={!canSubmit}
              >
                {isPending && <Spinner />}
                Submit
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
